module.exports = __webpack_public_path__ + "img/logo.9ff52ec9.png";